<template>
  <div class="date-warp">
    <span>{{ dateTxt }}</span>
    <div class="wh-flex-between">
      <span>{{ dateTime }}</span>
      <span>星期{{ dateDay }}</span>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'WhDateBox',
  data() {
    return {
      dateTxt: '',
      dateTime: '',
      dateDay: ''
    }
  },
  created() {
    setInterval(() => {
      this.getDateFn()
    }, 1000)
  },
  methods: {
    getDateFn() {
      const curDate = dayjs(new Date())
      this.dateTxt = curDate.format('YYYY年MM月DD日')
      this.dateTime = curDate.format('HH:mm:ss')
      this.dateDay = ['天', '一', '二', '三', '四', '五', '六'][curDate.day()]
    }
  }
}
</script>

<style scoped>
  .date-warp{
    color: #FFFFFF;
    font-size: 26px;
    letter-spacing: 3px;
  }
</style>
